import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class ClaimsErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/Claims\/Create/,
      messages: {
        400: 'errors.submitClaimFailed',
        404: 'errors.submitClaimFailed',
        500: 'errors.submitClaimFailed',
        success: {
          default: 'errors.submitClaimFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/Country\/Search/,
      messages: {
        400: 'errors.searchCountriesFailed',
        404: 'errors.searchCountriesFailed',
        500: 'errors.searchCountriesFailed',
        success: {
          default: 'errors.searchCountriesFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 3000
      }
    },
    {
      pattern: /\/Currency\/Search/,
      messages: {
        400: 'errors.searchCurrenciesFailed',
        404: 'errors.searchCurrenciesFailed',
        500: 'errors.searchCurrenciesFailed',
        success: {
          default: 'errors.searchCurrenciesFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 3000
      }
    },
    {
      pattern: /\/Claims\/Person/,
      messages: {
        400: 'errors.getPersonClaimsFailed',
        404: 'errors.getPersonClaimsFailed',
        500: 'errors.getPersonClaimsFailed',
        success: {
          default: 'errors.getPersonClaimsFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
